import { render, staticRenderFns } from "./baozhuangMb.vue?vue&type=template&id=83bf345a&scoped=true&"
import script from "./baozhuangMb.vue?vue&type=script&lang=js&"
export * from "./baozhuangMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bf345a",
  null
  
)

export default component.exports